/**
 * Fantasy Console 0 - Editor Sidebar
 *
 * Vertical icon-based navigation for editor sub-tabs (Code, Sprites, Map, Sound).
 * Only visible when the active view is 'editor'.
 */

import { useCart } from '../../context/CartContext'
import { EditorTabId } from '../../types'
import styles from './EditorSidebar.module.css'

const EDITOR_NAV: { id: EditorTabId; label: string; shortcut: string }[] = [
  { id: 'code', label: 'Code', shortcut: '1' },
  { id: 'sprites', label: 'Sprites', shortcut: '2' },
  { id: 'map', label: 'Map', shortcut: '3' },
  { id: 'sound', label: 'Sound', shortcut: '4' },
]

export function EditorSidebar() {
  const { activeTab, setActiveTab } = useCart()

  return (
    <nav
      className={styles.sidebar}
      role='tablist'
      aria-label='Editor navigation'
    >
      {EDITOR_NAV.map((item) => (
        <button
          key={item.id}
          role='tab'
          aria-selected={activeTab === item.id}
          className={`${styles.navButton} ${activeTab === item.id ? styles.active : ''}`}
          onClick={() => setActiveTab(item.id)}
          title={`${item.label} (Ctrl + ${item.shortcut})`}
        >
          <SidebarIcon id={item.id} />
          {/* <span className={styles.label}>{item.label}</span> */}
        </button>
      ))}
    </nav>
  )
}

function SidebarIcon({ id }: { id: EditorTabId }) {
  switch (id) {
    case 'code':
      return (
        <svg
          width='20'
          height='20'
          viewBox='0 0 18 18'
          fill='none'
          stroke='currentColor'
          strokeWidth='1.5'
        >
          <path d='M6 5L2 9l4 4M12 5l4 4-4 4M10 3L8 15' />
        </svg>
      )
    case 'sprites':
      return (
        <svg
          width='20'
          height='20'
          viewBox='0 0 18 18'
          fill='none'
          stroke='currentColor'
          strokeWidth='1.5'
        >
          <rect x='2' y='2' width='6' height='6' rx='1' />
          <rect x='10' y='2' width='6' height='6' rx='1' />
          <rect x='2' y='10' width='6' height='6' rx='1' />
          <rect x='10' y='10' width='6' height='6' rx='1' />
        </svg>
      )
    case 'map':
      return (
        <svg
          width='20'
          height='20'
          viewBox='0 0 18 18'
          fill='none'
          stroke='currentColor'
          strokeWidth='1.5'
        >
          <path d='M1 4l5-2 6 2 5-2v12l-5 2-6-2-5 2V4z' />
          <path d='M6 2v12M12 4v12' />
        </svg>
      )
    case 'sound':
      return (
        <svg
          width='20'
          height='20'
          viewBox='0 0 18 18'
          fill='none'
          stroke='currentColor'
          strokeWidth='1.5'
        >
          <path d='M3 7v4h3l4 4V3L6 7H3z' />
          <path d='M13 6.5a3 3 0 0 1 0 5' />
          <path d='M15 4.5a6 6 0 0 1 0 9' />
        </svg>
      )
    default:
      return null
  }
}
